module.exports = __webpack_public_path__ + "static/media/E1.fe58df7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/E1.mp4
// module id = AztU
// module chunks = 8